// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSocialYoukouWordmark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m11.276 9.681-2.993 6.73c-.084.188-.165.38-.246.57-.406.962-.81 1.918-1.59 2.421-3.179.198-1.776-2.658-.867-4.506.192-.391.362-.737.462-1a93.622 93.622 0 0 0-1.646-2.935L2.983 8.526c-.053-.091-.115-.192-.181-.3-.528-.858-1.34-2.179-.295-2.963.43-.326 1.394-.335 1.835 0 .77.59 1.35 1.759 1.915 2.894.432.868.854 1.717 1.343 2.273.322-.54.617-1.233.926-1.96.047-.109.094-.219.14-.33l.158-.362c.104-.234.204-.492.305-.754.279-.723.565-1.467.989-1.76.888-.613 2.264-.08 2.446.815.172.845-.386 1.882-.863 2.769-.161.3-.313.582-.425.833zm7.611 1.02c.316.427.821.802 1.334 1.181.632.468 1.274.944 1.59 1.539.54 1.018-.106 2.42-1.565 2.106-.492-.106-.956-.615-1.42-1.124-.206-.227-.412-.453-.621-.644a30.001 30.001 0 0 0-.964-.827c-.392-.328-.766-.64-1.071-.939-.315-.469-.299.098-.283.628.003.113.007.224.007.323v1.632c-.071.583-.389.922-.947 1.019h-.818c-.588-.068-.835-.48-.953-1.019V7.031c.012-1.442 2.712-1.442 2.718 0v2.65c.323-.164.553-.425.782-.686.08-.09.158-.18.24-.265.277-.221.524-.47.748-.748a13.56 13.56 0 0 0 1.288-1.291c.541-1.113 2.63-1.037 2.788.34.136 1.192-.827 1.9-1.684 2.532-.514.378-.99.729-1.169 1.138z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSocialYoukouWordmark;
